const $coverageAreaButton = $("#trigger-coverage-area-cart-page");

/**
 * Displays the Coverage Area Modal on Cart Page
 */
const showCoverageAreaModal = () => {
    if (!$coverageAreaButton.length) {
        return; 
    }
    $(".js-coverage-area-postal").first().trigger("click");
};

export { showCoverageAreaModal };
